import NewsStory from'./NewsStory';export default NewsStory;